import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import axios from "axios";
import { jwtDecode } from 'jwt-decode'; // Importation corrigée
import { baseApiUrl } from "../../services/api";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Question = () => {
  const [image, setImage] = useState("");
  const [titre, setTitre] = useState("");
  const [categorieId, setCategorieId] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [sviewingProjet, setSviewingProjet] = useState("");



  const [description, setDescription] = useState("");
  const [projets, setProjets] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [reponses, setReponses] = useState([]);


  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);
  const [viewingProjet, setViewingProjet] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState(null);
  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  // const truncateText = (text, wordLimit) => {
  //   const words = text.split(" ");
  //   if (words.length > wordLimit) {
  //     return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
  //   }
  //   return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
  // };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
      }
      return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
    } else {
      return ""; // Retourne une chaîne vide si text est undefined ou null
    }
  };

  const fetchQuestions = async () => {
    try {
      const response = await baseApiUrl.get(
        "/question/liste"
      );
      console.log("Données reçues des questions:", response.data);

      // Vérifie que les données sont bien un tableau avant de les stocker
      setQuestions(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des questions:", error);
    }
  };

  const fetchReponses = async () => {
    try {
      const response = await baseApiUrl.get(
        "/reponse/liste"
      );
      console.log("Données reçues des reponses:", response.data);

      // Vérifie que les données sont bien un tableau avant de les stocker
      setReponses(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des questions:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get('/categorie/liste');

      // Transformer les données pour correspondre au format des options de <Select>
      const options = response.data.map((category) => ({
        value: category.id, // Utiliser l'identifiant ou un autre attribut unique de la catégorie
        label: category.nom, // Utiliser le nom ou un autre attribut descriptif de la catégorie
      }));

      setCategoriesOptions(options);
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories:', error);
    }
  };

  useEffect(() => {

    fetchReponses();
    fetchQuestions();
    fetchCategories();
  }, []);


  const handleDelete = async (idProjet) => {
    try {
      const response = await baseApiUrl.delete(`/reponse/delete/${idProjet}`);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      setReponses(projets.filter((projet) => projet.id !== idProjet));
      setDeleteModalVisible(false);
      setDeleteProjet(null);
      openNotificationWithIcon("success", "Projet supprimé avec succès.");
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de la suppression du projet."
      );
      console.error("Erreur:", error);
    }
  };




  const handleStatusChange1 = async (key, value) => {
    // Vérifiez que key (ID du projet) est bien défini
    console.log("ID du question:", key); // Assurez-vous que key n'est pas undefined

    if (!key) {
      console.error("ID du projet est manquant !");
      return;
    }

    try {
      // Appel à l'API pour activer ou désactiver le projet
      const response = await baseApiUrl.put(
        `/question/activeDesactive/${key}`,
        {
          actif: value, // Passez la valeur de l'état actif
        }
      );

      // Vous pouvez afficher la réponse de l'API si nécessaire
      console.log(response.data);
      fetchQuestions(); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour de question:", error); // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
      // Rétablir l'état précédent en cas d'erreur
      const revertedData = data.map((item) => {
        if (item.id === key) {
          return { ...item, actif: !value };
        }
        return item;
      });
      setData(revertedData);

    }
  };
  const handleStatusChangeResponsessd = async (idReponse, actif) => {
    if (!idReponse) {
      console.error("Erreur : L'ID de la réponse est manquant !");
      return;
    }

    try {
      console.log(`Mise à jour de l'état de la réponse avec ID : ${idReponse}, Actif : ${actif}`);

      // Appeler l'API pour mettre à jour le statut de la réponse
      await baseApiUrl.put(`/reponse/activeDesactive/${idReponse}`, {
        actif: actif, // true ou false
      });

      console.log("Réponse activée/désactivée avec succès");

      // Mettre à jour l'état local de viewingProjet
      setViewingProjet((prevProjet) => ({
        ...prevProjet,
        reponses: prevProjet.reponses.map((reponse) =>
          reponse.id === idReponse ? { ...reponse, actif: actif } : reponse
        ),
      }));
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la réponse :", error);

      // Optionnel : Rétablir l'état précédent en cas d'échec
      setViewingProjet((prevProjet) => ({
        ...prevProjet,
        reponses: prevProjet.reponses.map((reponse) =>
          reponse.id === idReponse ? { ...reponse, actif: !actif } : reponse
        ),
      }));
    }
  };


  const handleStatusChangeResponse = async (key, value) => {
    // Vérifiez que key (ID du projet) est bien défini
    console.log("ID du reponse:", key); // Assurez-vous que key n'est pas undefined

    if (!key) {
      console.error("ID du projet est manquant !");
      return;
    }

    try {
      // Appel à l'API pour activer ou désactiver le projet
      const response = await baseApiUrl.put(
        `/reponse/activeDesactive/${key}`,
        {
          actif: value, // Passez la valeur de l'état actif
        }
      );

      // Vous pouvez afficher la réponse de l'API si nécessaire
      console.log(response.data);
      fetchReponses(); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour du projet:", error); // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
      // Rétablir l'état précédent en cas d'erreur
      const revertedData = data.map((item) => {
        if (item.id === key) {
          return { ...item, actif: !value };
        }
        return item;
      });
      setData(revertedData);

    }
  };


  const handleView = (projet) => {
    setViewingProjet(projet);
    setIsViewModalVisible(true);
  };
  const handleStatusChangeResponseA = async (idReponse, actif) => {
    if (!idReponse) {
      console.error("Erreur : L'ID de la réponse est manquant !");
      return; // Arrête l'exécution si l'ID est null ou undefined
    }

    try {
      // Envoyer la requête PUT pour mettre à jour l'état actif de la réponse
      const response = await baseApiUrl.put(`/reponse/activeDesactive/${idReponse}`, {
        actif: actif, // Valeur true ou false
      });
      console.log("Réponse activée/désactivée :", response.data);

      // Rafraîchir les questions et réponses après la mise à jour
      fetchQuestions(); // Appelez cette fonction pour actualiser les données
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la réponse :", error);

      // Facultatif : Afficher une notification d'erreur ou restaurer l'état précédent
    }
  };


  const filteredProjets = questions.filter((question) =>
    question.titre && question.titre.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Forums</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                type="success"
                  onClick={() => setIsAddModalVisible(true)}
                  className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faQuestionCircle} className="me-2" /> {/* Icône ajoutée ici */}
                  Poser une question
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              {
                title: "N° question",
                dataIndex: "id",
                key: "id",
              },
              {
                title: "Utilisateur",
                dataIndex: ["utilisateur", "nom"],
                key: "nom",
              },
              {
                title: "Photo",
                dataIndex: ["utilisateur", "photo"],
                key: "photo",
                render: (imageName) => {
                  const imageUrl = baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="utilisateur"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },
              {
                title: "Question",
                dataIndex: "description",
                key: "description",
                render: (text) => truncateText(text, 6),
              },
              {
                title: "Domaines",
                dataIndex: ["categorie", "nom"],
                key: "categorie",
              },
              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) =>
                      handleStatusChange1(record.id, checked)
                    }
                  />
                ),
              },
              {
                title: "Actions",
                key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => handleView(record)}
                    >
                      Voir
                    </Button>
                    {/* <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => handleEdit(record)}
                    >
                      Modifier
                    </Button> */}
                    <Button
                      disabled
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDelete(record.id)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={questions}
          />

          {/* Modal pour afficher les détails  */}
          <Modal
            title="Détails de la question"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
          >
            {viewingProjet && (
              <div>
                <h3>Question :</h3>
                <strong> <p>{viewingProjet.description}</p></strong>

                <h4>Domaine :</h4>
                <p>{viewingProjet.categorie.nom}</p>

                <h4>Réponses :</h4>
                <ul>
                  {viewingProjet.reponses.map((reponse, index) => (
                    <li key={index}>
                      <Switch
                        checked={reponse.actif}
                        onChange={(checked) => {
                          // Gérer le changement d'état
                          handleStatusChangeResponse(reponse.id, checked);
                        }}


                        style={{ marginRight: "10px" }}
                      />



                      <strong>{reponse.utilisateur.nom} :</strong> {reponse.contenu}
                    </li>
                  ))}
                </ul>
              </div>
            )}



          </Modal>
        </div>
      </div>
    </>
  );

};

export default Question;
